import React from "react";
import {
  FiEdit2,
  FiExternalLink,
  FiEye,
  FiImage,
  FiMap,
  FiToggleLeft,
  FiToggleRight,
  FiTrash2,
} from "react-icons/fi";

import { toAbsolutePublicUrl } from "../../../../services/mediaLibraryServices";

import AdminButton from "../../_shared/ui/AdminButton";
import ProjetStatusBadge from "./ProjetStatusBadge";

import {
  formatDateTime,
  getProjetUrlLabel,
  truncateText,
} from "../utils/projetsAdminUtils";

export default function ProjetCard({
  item,
  actionId,
  onPreview,
  onEdit,
  onToggle,
  onAskDelete,
}) {
  const imageUrl = item?.image_projet_url
    ? toAbsolutePublicUrl(item.image_projet_url)
    : "";

  const toggleLoading = actionId === `toggle-${item.id}`;

  return (
    <article className="group overflow-hidden rounded-[1.7rem] border border-slate-200 bg-slate-50 transition hover:-translate-y-0.5 hover:border-orange-200 hover:bg-white hover:shadow-xl hover:shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-950 dark:hover:border-orange-500/30 dark:hover:bg-slate-900 dark:hover:shadow-black/20">
      <div className="grid min-h-full lg:grid-cols-[220px_1fr]">
        <div className="relative min-h-[220px] overflow-hidden bg-slate-200 dark:bg-slate-800">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.titre}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full min-h-[220px] flex-col items-center justify-center gap-3 bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 dark:from-slate-800 dark:to-slate-900 dark:text-slate-500">
              <FiImage className="text-4xl" />
              <span className="text-xs font-bold uppercase tracking-[0.18em]">
                Sans image
              </span>
            </div>
          )}

          <div className="absolute left-3 top-3">
            <ProjetStatusBadge active={!!item.is_active} />
          </div>
        </div>

        <div className="flex min-w-0 flex-col p-4 sm:p-5">
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-2.5 py-1 text-xs font-bold text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
                <FiMap />
                Projet
              </span>

              {item.page_detail_url ? (
                <span className="inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-sky-50 px-2.5 py-1 text-xs font-bold text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300">
                  <FiExternalLink />
                  {getProjetUrlLabel(item.page_detail_url)}
                </span>
              ) : null}
            </div>

            <h3 className="mt-3 line-clamp-2 text-lg font-bold leading-snug text-slate-950 dark:text-white">
              {item.titre || "Sans titre"}
            </h3>

            <p className="mt-3 line-clamp-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {truncateText(item.description, 210) ||
                "Aucune description renseignée."}
            </p>

            <p className="mt-3 text-xs font-bold text-slate-400 dark:text-slate-500">
              Créé le {formatDateTime(item.created_at)}
            </p>
          </div>

          <div className="mt-5 flex flex-wrap gap-2">
            <AdminButton
              icon={FiEye}
              variant="secondary"
              size="sm"
              onClick={() => onPreview(item.id)}
            >
              Voir
            </AdminButton>

            <AdminButton
              icon={FiEdit2}
              variant="soft"
              size="sm"
              onClick={() => onEdit(item.id)}
            >
              Modifier
            </AdminButton>

            <AdminButton
              icon={item.is_active ? FiToggleLeft : FiToggleRight}
              variant={item.is_active ? "secondary" : "primary"}
              size="sm"
              loading={toggleLoading}
              onClick={() => onToggle(item.id)}
            >
              {item.is_active ? "Masquer" : "Publier"}
            </AdminButton>

            <AdminButton
              icon={FiTrash2}
              variant="dangerSoft"
              size="sm"
              onClick={() => onAskDelete(item.id)}
            >
              Supprimer
            </AdminButton>
          </div>
        </div>
      </div>
    </article>
  );
}